(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-personalizado-az"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  class FooterAccordion {
    constructor(container) {
      this.container = container;
      this.accordions = this.container.querySelectorAll('.js-toggle');
      this.mediaQuery = window.matchMedia('(max-width: 989px)');
      
      this.toggle = this.toggle.bind(this);
      this.init();
      this.mediaQuery.addEventListener('change', this.init.bind(this));
    }

    init() {
      if (this.mediaQuery.matches) {
        this.addAccordionListeners();
      } else {
        this.removeAccordionListeners();
      }
    }
    
    addAccordionListeners() {
      this.accordions.forEach(heading => {
        const content = heading.nextElementSibling;
        if (content) {
          heading.setAttribute('aria-expanded', 'false');
          content.style.display = 'none';
        }
        heading.removeEventListener('click', this.toggle);
        heading.addEventListener('click', this.toggle);
      });
    }

    removeAccordionListeners() {
      this.accordions.forEach(heading => {
        const content = heading.nextElementSibling;
        if (content) {
          heading.setAttribute('aria-expanded', 'true');
          content.style.display = 'block';
        }
        heading.removeEventListener('click', this.toggle);
      });
    }
    
    toggle(event) {
        const heading = event.currentTarget;
        const content = heading.nextElementSibling;
        const isExpanded = heading.getAttribute('aria-expanded') === 'true';
        
        heading.setAttribute('aria-expanded', !isExpanded);
        content.style.display = isExpanded ? 'none' : 'block';
    }
  }

  const footerContainer = document.querySelector('[data-section-type="az-custom-footer"]');
  if (footerContainer) {
    new FooterAccordion(footerContainer);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
